export default __webpack_public_path__ + "static/media/1654.44af62ae.png";